import { useMergeDim } from "../../hooks/manageCubes/useMergeDim";
import { normalizeDimValue, storedDimValues } from "./dimensionValueValidation";
import { DimMappingOperationForm } from "./DimMappingOperationForm";
import { intakeScopeWarning } from "./intakeScopeWarning";

/** Props for the Merge Dimension operation form. */
interface MergeOperationProps {
  /** The target cube ID to merge dimension values in. */
  cubeId: string;
}

export function MergeOperation({ cubeId }: MergeOperationProps) {
  const mergeDim = useMergeDim();

  return (
    <DimMappingOperationForm
      cubeId={cubeId}
      mutation={mergeDim}
      actionText="Merge"
      dialogTitle="Merge Dimension"
      dialogBody="Merge the following dimensions into their targets. The source values are deleted and rows already stored under a target are summed. This operation is irreversible."
      mappingListTitle="Merges:"
      allowMultiSource
      suggestExistingValues
      selectionHint="Select context elements. A dimension is only merged when you give it a target below — otherwise it just filters what the merge applies to."
      mappingHint="Type a target for each dimension you want to merge: every value selected on it is summed into that target, and a target that does not exist yet behaves like a rename. Leave a target blank to use that dimension as a filter only."
      fieldLabel={(dimLabel) => `Merge ${dimLabel} into`}
      fieldPlaceholder={(dimLabel) =>
        `Target ${dimLabel.toLowerCase()} (blank = filter only)`
      }
      editPromptError="Enter a target for at least one dimension to merge into."
      validateTarget={(sources, value) =>
        sources.length === 1 &&
        normalizeDimValue(sources[0]) === normalizeDimValue(value)
          ? "Same as the selected value — nothing to merge."
          : undefined
      }
      mappingAnnotation={(existing, value) =>
        storedDimValues(existing, value).length > 0
          ? "(existing value — rows will be summed)"
          : "(new value — behaves like a rename)"
      }
      dialogWarning={intakeScopeWarning}
    />
  );
}
